export class PaymentPlanDetail {
  targetYear!:number
  unitPrice!:number
}

export class PaymentPlanPostRequest {
  planName!:string
  paymentPlanDetail!:PaymentPlanDetail[]
}
